
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import SchoolCard from '../SchoolCard.jsx';
import Filter from '../Filter.jsx';
import SortFilter from '../SortFilter.jsx';
import GoogleMap from '../Map.jsx';
import Search from '../Search.jsx';

import CountUp from 'react-countup';

import t from '../utils/i18n.js';

const Schools = (props) => {
    const [mapActive, setMapActive] = useState(false);

    if (props.lang !== 'en') {
        let location = useLocation();

        useEffect(() => {
            document.getElementById('hero-img-schools').classList.add('hero__picture--active');
            document.getElementById('hero-img-courses').classList.remove('hero__picture--active');
            const header = document.querySelector('.hero__text');
            header.classList.remove('hero__text--courses');
            header.classList.add('hero__text--schools');
        }, [location]);
    }

    const schools = (
        <div className="sorting__schools-bk">
            <div className="sorting__container sorting__container--schools" id="sort-filters">
                <div className="sorting">
                    <Search
                        sort={props.sortSchools}
                        value={props.filters.schools.schoolname}
                        placeholder={t("Søk skolenavn...", props.lang)}
                    />
                    <Filter
                        type="christian"
                        title={t("Verdigrunnlag", props.lang)}
                        options={props.options.schools.religion}
                        checked={props.filters.schools.christian}
                        sort={props.sortSchools}
                        trackingCategory="skolesøk"
                        trackingAction="tilknytning"
                        lineCount={props.filteredSchools.length}
                        itemName={t("skoler", props.lang)}
                        lang={props.lang}
                    />
                    <Filter
                        type="county"
                        title={t("Landsdel", props.lang)}
                        options={props.options.schools.county}
                        checked={props.filters.schools.county}
                        sort={props.sortSchools}
                        trackingCategory="skolesøk"
                        trackingAction="landsdel"
                        lineCount={props.filteredSchools.length}
                        itemName={t("skoler", props.lang)}
                        lang={props.lang}
                    />
                    <div className="filter__wrapper">
                        <button
                            className={'filter__toggle filter__toggle--map' + (mapActive ? ' filter__toggle--active' : '')}
                            onClick={() => setMapActive(!mapActive)}
                        >
                            {mapActive ? t("Skjul kart", props.lang) : t("Vis kart", props.lang)}
                        </button>
                        <div className={ 'filter__container filter__container--map' + (mapActive ? ' filter__container--active' : '') }>
                            <div className="map__container map__container--front" id="filter-map">
                                {mapActive && <GoogleMap schools={props.filteredSchools} />}
                            </div>
                        </div>
                    </div>
                    <SortFilter
                        shuffle={props.shuffle}
                        unShuffle={props.unShuffle}
                        lang={props.lang}
                    />
                    <div className="filter__show-result filter__show-result--schools">
                        <a className="button button--primary" onClick={() => document.getElementById('linjer').scrollIntoView({ behavior: 'smooth' })}>
                            {t("Vis", props.lang)} <CountUp end={props.filteredSchools.length} duration={1} preserveValue={true}></CountUp> {t("skoler", props.lang)}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <div>
            {schools}
            <div className="filter__breadcrumbs" id="linjer">
                <nav className="breadcrumb">
                    <ul>
                        <li className="breadcrumb__item"><a href="/">{t("Hjem", props.lang)}</a></li>
                        <li className="breadcrumb__item"><a onClick={() => document.getElementById('sort-filters').scrollIntoView({ behavior: 'smooth' })}>{t("Finn din skole", props.lang)}</a></li>
                        <li className="breadcrumb__item">{t("Resultat", props.lang)}</li>
                    </ul>
                </nav>
            </div>
            { props.filteredSchools.length === 0 ? (
                <h2 className="center">{t("Fant ingen skoler", props.lang)}</h2>
            ) : null }
            <SchoolCard schools={props.filteredSchools} lang={props.lang} />
        </div>
    );
};

Schools.propTypes = {
    filteredSchools: PropTypes.array,
    sortSchools: PropTypes.func,
    resetFilters: PropTypes.func,
    shuffle: PropTypes.func,
    unShuffle: PropTypes.func,
    filtersActive: PropTypes.bool,
    options: PropTypes.object,
    filters: PropTypes.object,
};

export default Schools;
